import {h} from "preact";

export const ICON_CHECKBOX = (
	<svg class="_membership-icon" width="24" height="24" viewBox="0 0 24 24">
		<path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/>
		<path d="M0 0h24v24H0z" fill="none"/>
	</svg>
);

export const ICON_CHEVRON = (
	<svg class="_membership-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path d="M5.88 4.12L13.76 12l-7.88 7.88L8 22l10-10L8 2z"/>
		<path fill="none" d="M0 0h24v24H0z"/>
	</svg>
);

export const ICON_CHECKBOX_CHECKED = (
	<svg class="_membership-icon" width="24" height="24" viewBox="0 0 24 24">
		<path d="M0 0h24v24H0z" fill="none"/>
		<path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
	</svg>
);

export const ICON_RADIO = (
	<svg class="_membership-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
		<path d="M0 0h24v24H0z" fill="none"/>
	</svg>
);

export const ICON_RADIO_CHECKED = (
	<svg class="_membership-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"/>
		<path d="M0 0h24v24H0z" fill="none"/>
	</svg>
);

export const ICON_CHECK = (
	<svg class="_membership-icon" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
		<path d="M0 0h24v24H0z" fill="none"/>
		<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>
	</svg>
);
